/** Shared disability-facts helpers for General Profile and Family Info. */

export type DisabilityCategory = 'none' | 'general' | 'special';

export function needsDisabilityFacts(category: DisabilityCategory | '' | string | null | undefined): boolean {
  return category === 'general' || category === 'special';
}

/** Serialize disability narrative into the single DB JSON column. */
export function disabilityFactsToJson(description: string): string {
  return JSON.stringify({ description: description.trim() });
}

/** Read description from disability_facts_json (JSON or plain-text fallback). */
export function disabilityFactsFromJson(raw: string | null | undefined): string {
  if (raw == null) return '';
  const s = String(raw).trim();
  if (!s) return '';
  if (!s.startsWith('{')) return s;
  try {
    const parsed = JSON.parse(s) as { description?: unknown };
    return typeof parsed.description === 'string' ? parsed.description.trim() : '';
  } catch {
    return s;
  }
}
